window.theme = window.theme || {};
$(document).ready(function () {

         variantFirstValue();

        $('.pro_variant_item_outer').click(function () {  //Swatch click
           changeVariantElements($(this));
         });

          $('.pills_variant_products').click(function () {  //Swatch click
           changeVariantValue($(this));
         });


        $('#truncated').click(function(){
          $('#truncated').fadeOut(300, function(){
            $('#fullDescription').fadeIn(500);
          });
        });

        $(".video-image-button").click(function(){
              $(".video-popup-screen").fadeIn(1000);
            });
           $(".cross-btn-times").click(function(){
                $(".video-popup-screen").fadeOut(1000);
                $('.iframe-stopped-playing').each(function(index) {
                $(this).attr('src', $(this).attr('src'));
                return false;
              });
            });

              $(".multicolumn-video-image").click(function(){
                $("img.video_play_click").hide();
                $(".image-multicolumn").hide();
                $(".video-multicolumn").show();
            });

 $('button.quantity__button.no-js-hidden').on('click', function() {
       console.log('plus clicked')
     // var input = $(this).siblings('.quantity__input');
     //  var currentValue = parseInt(input.val());
     //  var maxValue = parseInt(input.attr('max'));

     //  if (!maxValue || currentValue < maxValue) {
     //    input.val(currentValue + 1);
     //  }
    });

      $(".header__inline-menu .header-menu").mouseover(function(){
        $(this).find("details").attr("open","");
        $(this).find("summary").attr("aria-expanded","true");
      });

      $(".header__inline-menu .header-menu").mouseleave(function(){
          if($(this).find("details").attr("open")){
           $(this).find("details").removeAttr("open");
          }
          if($(this).find("summary").attr("aria-expanded") == "true"){
           $(this).find("summary").attr("aria-expanded","false");
          }
      });

  });

/*
* Function: Swatch Image Function: Handle Price, text in it
*/
  function changeVariantElements(variantAtt){
    //Gather price, images, compare price  data
    var variantPrice = variantAtt.data("price");
    var variantCompareAtPrice = variantAtt.data("compareprice");
    var variantImageSrc = variantAtt.data('image');
    var variantUrl = variantAtt.data('url');

    //Assign the values
    variantAtt.parents(':eq(5)').find('.product-card-wrapper').find('img').attr('srcset', variantImageSrc);
    variantAtt.parents(':eq(3)').find('.card__content__main').find('.myChangedUrl').attr('href',variantUrl);
    variantAtt.parents(':eq(3)').find('.card-information_price').find('.priceChangedText').html(variantPrice);
}

/*
* Function: Swatch color name Function: Handle variant color one click
*/
function changeVariantValue(variantAtt){

   var variantValue = variantAtt.attr('title');
   variantAtt.parents(':eq(3)').find('.parent_color_name').find('.color_name_change').html(variantValue);

  console.log( variantAtt.parents(':eq(3)').find('.parent_color_name').find('.color_name_change').html(variantValue));

}
/*

* Function: Swatch color name Function: Handle on load first variant color name display
*/
function variantFirstValue() {
    var firstVariantProduct = $('.pills_variant_products').first();
    var myValueColor = $('.color_name_change');
    var variantValue = firstVariantProduct.attr('title');

      myValueColor.html(variantValue);

}
(function($){
  var $ = jQuery = $;

  $(function() {


    $('body').find('.upsell-product-remove').each(function() {
      new theme.UpsellProductRemove($(this), {
        namespace: '#cartpage'
      });
    });

    // if($('.template-cart #addons').length > 0){
    // 	new theme.AddOnDisplay();
    // }



    if($('.off-canvas-cart').length > 0){
    	//new theme.CartDrawer();
    }

    if($('.cart-form').length > 0){
      new theme.AddOnCheckout($('.cart-form'));

    }

     $('body').on('click', '.cart-checkout-addon', function() {
      $(this).addClass('btn--clicked');
    });

    $('body').on('click', '.upsell_widget_close', function() {
      $('#upsell_widget_modal').hide();
    });



    $(".addon-quantity").change(function(){
      var maxValue = parseInt($(this).attr('max'));
      var quantity = parseInt($(this).val());
      if(quantity > maxValue){
      	$('.notify_genie').notify('Allowed quantity is '+maxValue,{ position:"bottom center", className: "error" } );
        $(this).val(maxValue);
      }
    });

    $(".product-update").change(function(){
      var quantity = $(this).val();
      var variant = $(this).data('variant');
      if(quantity == 0){
      	 theme.genie.getCart().then(function(cart) {
              var canBeRemoved = true;
               var addonToRemoved = [];
              $.each(cart.items, function(index, product) {
                $.each(product.properties, function(key,value) {
                    if(key == 'combo' && value == variant ){
                      canBeRemoved = false;
                      addonToRemoved.push(product.variant_id);
                    }
                  });
              });
               addonToRemoved.push(variant);

               $.each(addonToRemoved, function(key,variant) {
                 $('.addonitem-'+variant).val(0);
                 $('.item-'+variant).val(0);
               });

               $('.cart-form').submit();
          }.bind(this));
      }else{
        $('.item-'+variant).val(quantity);
      }

    });







  });

  theme.config = {
    BASE_URL:'https://wolfathletics.thegenielab.com/'
  };


  theme.genie = {
     getCart: function() {
      return $.getJSON('/cart.js');
    },
    _sendAjax: function(params) {
      return $.ajax(params)
          .then(function(data) {
            return data;
          }.bind(this))
    },
    getAddOns: function(url,data) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType:"json",
      });
    },
    addProductToOrder: function(url,data) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType:"json",
      });
    },
    addItemFromForm: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },
    _updateCart: function(params) {
      return $.ajax(params)
        .then(function(cart) {
          return cart;
        }.bind(this))
    },
    saveForm: function(data,url) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        crossDomain: true
      });
    },


    showError: function(el,message){
      el.append('<div class="errors text-center">'+message+'</div>');
      setTimeout(function(){
        el.find('.errors').remove();
      }, 3000);
    },
    setCookie: function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },


  }

    theme.AddOnDisplay = (function() {
    var config = {
      namespace: '.productpage'
    };

    var selectors = {
      container: '#addons_container',
      template: '#addons_template',
      variantsSelection: '#id',
      type: ''
    };

    function AddOnDisplay() {
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);
      var shop = $(selectors.container).data('store');
      var variant = $(selectors.variantsSelection).val();
      var url = theme.config.BASE_URL+'json/product/addons?shop='+shop;
      var selectedAddons = [];
      var variants = [];


      $('body').find('.added_addons').each(function() {
        selectedAddons.push($(this).val());
      });

      if(typeof variant === 'undefined') {
      	$('body').find('#mini-cart-form .cart-item').each(function() {
          console.log($(this).find('.quantity__input'));
          var variantId = $(this).data('variant');
          if(typeof variantId === 'undefined') {

          }else{
            if(variantId.length >1){
              variants.push(variantId+'::'+$(this).find('.quantity__input').val());
            }
          }

        });
      }else{
        variants.push(variant);
      }
      console.log(variants);

      var data = {selected:selectedAddons,variants:variants};
      theme.genie.getAddOns(url,data).then(this.displayValues.bind(this))
      .catch(function(XMLHttpRequest) {
                        $(selectors.container).html('');
                    }.bind(this));


      this.initEventListeners();

    };

     AddOnDisplay.prototype = $.extend({}, AddOnDisplay.prototype, {
      initEventListeners: function() {


      },
       displayValues: function(response) {
         if(response.status){

           if($('.template-cart #addons').length > 0){
                var cartPage = true;
           }else{
           		var cartPage = false;
           }

           var data = {
             addons: response.data,
             cartPage: cartPage

            };

		 	$(selectors.container).html(this.template(data));
            $('body').find('.addon_variant_select').each(function() {
              new theme.AddonSelectOption($(this), {
                namespace: '#productpage'
              });
            });
           $('body').find('.addon-cart-button').each(function() {
              new theme.AddAddOnToCart($(this), {
                namespace: '#productpage'
              });
            });


            $('#addons').show();

         }else{
         	$('#addons').hide();
         }
     		//console.log(response);



      },



    });

    return AddOnDisplay;
  })();

  theme.AddOnDisplayCartDrawer = (function() {
    var config = {
      namespace: '.productpage'
    };

    var selectors = {
      container: '#addons_container_drawer',
      template: '#addons_template',
      variantsSelection: '#id',
      type: ''
    };

    function AddOnDisplayCartDrawer() {
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);
      var shop = $(selectors.container).data('store');
      var variant = $(selectors.variantsSelection).val();
      var url = theme.config.BASE_URL+'json/product/addons?shop='+shop;
      var selectedAddons = [];
      var variants = [];


      if(typeof variant === 'undefined') {
      	$('body').find('.cart-drawer__form .cart-item').each(function() {
          var variantId = $(this).data('variant');
          if(typeof variantId === 'undefined') {

          }else{
            if(variantId.length >1){
              variants.push(variantId+'::'+$(this).find('.quantity__input').val());
            }
          }

        });
      }else{
        variants.push(variant);
      }

      var data = {selected:selectedAddons,variants:variants};
      theme.genie.getAddOns(url,data).then(this.displayValues.bind(this))
                    .catch(function(XMLHttpRequest) {
                        $(selectors.container).html('');
                         $('#CartDrawer').removeClass('upsell-drawer-wrapper');
                         $('#CartDrawer .upsell_drawer ').addClass('hidden');
                    }.bind(this));


      this.initEventListeners();

    };

     AddOnDisplayCartDrawer.prototype = $.extend({}, AddOnDisplayCartDrawer.prototype, {
      initEventListeners: function() {


      },
       displayValues: function(response) {
         if(response.status){

           if($('.template-cart #addons').length > 0){
                var cartPage = true;
           }else{
           		var cartPage = false;
           }

           var data = {
             addons: response.data,
             cartPage: cartPage

            };

		 	$(selectors.container).html(this.template(data));
             $('#CartDrawer').addClass('upsell-drawer-wrapper');
             $('#CartDrawer .upsell_drawer ').removeClass('hidden');

             $('body').find('.addon_variant_select').each(function() {
              new theme.AddonSelectOption($(this), {
                namespace: '#productpage'
              });
            });

           $('body').find('.addon-cart-button').each(function() {
              new theme.AddAddOnToCart($(this), {
                namespace: '#productpage'
              });
            });

         }else{
         	$(selectors.container).html('');
                         $('#CartDrawer').removeClass('upsell-drawer-wrapper');
                         $('#CartDrawer .upsell_drawer ').addClass('hidden');
         }
     		//console.log(response);



      },



    });

    return AddOnDisplayCartDrawer;
  })();

  theme.AddAddOnToCart = (function() {
    var classes = {
      input: '.addon-cart-button',
    };

    function AddAddOnToCart($el, options) {
      this.$wrapper = $el;
      this.$input = $el;

      var defaults = {
        namespace: null,
        key: this.$input.data('variant')
      };

      this.options = $.extend(defaults, options);

      this.initEventListeners();
    };

    AddAddOnToCart.prototype = $.extend({}, AddAddOnToCart.prototype, {
      initEventListeners: function() {
        this.$input.on('click', function() {
         //For Ram
            document.documentElement.dispatchEvent(new CustomEvent('upsell:added', {
                bubbles: true,
                detail: {
                    offer: this.$input.data('offer'),
                    price: this.$input.data('price'),
                    originalPrice: this.$input.data('originalprice'),
                    variant: this.$input.data('variant'),
                    comboVariant: this.$input.data('combovariant'),
                    comboProduct: this.$input.data('comboproduct'),
                    maxQty: this.$input.data('max'),
                    title: this.$input.data('title'),
                    image: this.$input.data('image'),
                }
            }))


        }.bind(this));
      },

      checkRule: function(cart) {
        var canBeAdded = false;
        var comboVariant = this.$input.data('combovariant');
        console.log(comboVariant);
		$.each(cart.items, function(index, product) {
          if(product.variant_id == comboVariant ){
          	canBeAdded = true;
          }
        });

        var addonQuantity = 0;
        var addonMaxQuantity = parseInt(this.$input.data('max'));
        var offerId = this.$input.data('offer');
		$.each(cart.items, function(index, product) {
          $.each(product.properties, function(key,value) {
              if(key == 'offer' && value == offerId ){
                addonQuantity = parseInt(product.quantity);
              }
            });
        });

        console.log(addonQuantity);

        if(canBeAdded){
          addonQuantity = addonQuantity + 1;
          if(addonQuantity <= addonMaxQuantity){
              var data = { items: [
              {quantity: 1,
               id:this.$input.data('variant'),
               properties: {
                            'offer':this.$input.data('offer'),
                            'price':this.$input.data('price'),
                            'title':this.$input.data('title'),
                            'type':'addon',
                            'max':this.$input.data('max'),
                            'image':this.$input.data('image'),
                            'combo':this.$input.data('combovariant'),
               }}]
                       };

              theme.genie.addItemFromForm(data)
                .then(function() {
                  this.success();

                  //$('.off-canvas-cart').addClass('in');
                }.bind(this))
                .catch(function(XMLHttpRequest) {
                  this.error(XMLHttpRequest)
                }.bind(this))
                .always(function() {

                }.bind(this));
          }else{
          		this.$input.notify('Allowed quantity is  '+addonMaxQuantity+' ',{ position:"bottom center", className: "error" });

          }

        }else{
        	this.$input.notify('Please add main product first',{ position:"bottom center", className: "error" });

        }

      },

	  success: function() {

		   new theme.CartDrawer();
            this.$input.val('ADDED');
            this.$input.attr('disabled','disabled');
            this.$input.removeClass('btn-primary');
            this.$input.addClass('btn-secondary');
            this.$input.notify('Offer added to cart',{ position:"bottom center", className: "success" });
        //$('.view-cart').show();
        if($('.template-cart #addons').length > 0){
        	location.reload();
        }

      },

      error: function(XMLHttpRequest) {
        alert(XMLHttpRequest.responseJSON.message);
      }
    });

    return AddAddOnToCart;
  })();

  theme.AddonSelectOption = (function() {
    var classes = {
      input: '.addon_variant_select',
    };

    function AddonSelectOption($el, options) {
      this.$wrapper = $el;
      this.$input = $el;

      var defaults = {
        namespace: null,
        key: this.$input.data('variant')
      };

      this.options = $.extend(defaults, options);

      this.initEventListeners();
    };

    AddonSelectOption.prototype = $.extend({}, AddonSelectOption.prototype, {
      initEventListeners: function() {
        this.$input.on('change', function() {
          var selectedOption = this.$input.find(':selected');
          var product = selectedOption.data('product');

          var cartButton = $('.addon-cart-button-'+product);
          cartButton.data('offer',selectedOption.data('offer'));
          cartButton.data('title',selectedOption.data('title'));
          cartButton.data('price',selectedOption.data('price'));
          cartButton.data('originalprice',selectedOption.data('originalprice'));
          cartButton.data('variant',selectedOption.data('variant'));
          cartButton.data('product',selectedOption.data('product'));
          cartButton.data('combovariant',selectedOption.data('combovariant'));
          cartButton.data('comboproduct',selectedOption.data('comboproduct'));
          cartButton.data('max',selectedOption.data('max'));
          cartButton.data('image',selectedOption.data('image'));
          $('.upsell-'+product+' .upsell-img').attr('src',selectedOption.data('image'));
          $('.upsell-'+product+' .upsell_widget_title').text(selectedOption.data('title'));
          $('.upsell-'+product+' .upsell-original-price').text(selectedOption.data('originalprice'));
          $('.upsell-'+product+' .upsell-price').text(selectedOption.data('price'));


        }.bind(this));
      },






    });

    return AddonSelectOption;
  })();

  theme.AddOnCheckout = (function() {
    var status = {
      loading: false
    };

    function AddOnCheckout($form) {
      this.$form = $form;
      this.$ajaxSubmit = $('.cart-checkout-addon');
      this.$updateSubmit = $('.cart-update-button');

      if (this.$form.length) {
        this.$form.on('submit', this.saveForm.bind(this));
      }
    };

    AddOnCheckout.prototype = $.extend({}, AddOnCheckout.prototype, {
      saveForm: function(evt){


		 if(this.$ajaxSubmit.hasClass('btn--clicked')){
           evt.preventDefault();


          // Loading indicator on add to cart button
          //this.$ajaxSubmit.addClass('Polaris-Button--loading');

          status.loading = true;
          this.$ajaxSubmit.LoadingOverlay("show");

          var data = this.$form.serialize();
		  var shop = this.$ajaxSubmit.data('store');
          var url = theme.config.BASE_URL+'json/draft-order?shop='+shop;

          theme.genie.saveForm(data,url)
              .then(function(response) {
                this.success(response);

              }.bind(this))
              .catch(function(XMLHttpRequest) {
                this.error(XMLHttpRequest)
              }.bind(this))
              .always(function() {
                status.loading = false;
                this.$ajaxSubmit.LoadingOverlay("hide");
                //this.$ajaxSubmit.removeClass('Polaris-Button--loading');
                this.$ajaxSubmit.removeClass('btn--clicked');
                //$('#scan_start').trigger('click');
              }.bind(this));
        }else{
          return;
        }



      },

      success: function(response) {
        if(response.status){
          //this.$ajaxSubmit.notify(response.message,{ position:"bottom center", className: "success" });
          if(response.status){
            var expiry = 15;
            theme.genie.setCookie('draft-order',response.token,expiry);
            window.location.href = response.url;
          }else{
          this.$ajaxSubmit.notify(response.message,{ position:"bottom center", className: "error" });
          }

        }else{
          this.$ajaxSubmit.notify(response.message,{ position:"bottom center", className: "error" });
        }

      },

      error: function(XMLHttpRequest) {
        console.warn(XMLHttpRequest.responseJSON.message);
        this.$ajaxSubmit.notify(XMLHttpRequest.responseJSON.message,{ position:"top right", className: "error" });
      }
    });

    return AddOnCheckout;
  })();

  theme.AjaxProductAdd = (function() {
    var status = {
      loading: false
    };

    function AjaxProductAdd($form) {
      this.$form = $form;
      this.$ajaxSubmit = $('#AddToCart');

      if (this.$form.length) {
        this.$form.on('submit', this.saveForm.bind(this));
      }
    };

    AjaxProductAdd.prototype = $.extend({}, AjaxProductAdd.prototype, {
      saveForm: function(evt){


		 if(this.$ajaxSubmit.hasClass('btn--clicked')){
           evt.preventDefault();


          // Loading indicator on add to cart button
          //this.$ajaxSubmit.addClass('Polaris-Button--loading');

          status.loading = true;
          this.$ajaxSubmit.LoadingOverlay("show");

          var data = { items: [
            { quantity: $('#Quantity').val(),
             id:$('#id').val(),
             }]
                     };
		   var url = this.$form.attr('action');

          theme.genie.addItemFromForm(data)
              .then(function(response) {
                this.success(response);
				addToCart();
              }.bind(this))
              .catch(function(error) {
                this.error(error)
              }.bind(this))
              .always(function() {
                status.loading = false;
                this.$ajaxSubmit.LoadingOverlay("hide");
                this.$ajaxSubmit.removeClass('btn--clicked');
              }.bind(this));
        }else{
          return;
        }



      },

      success: function(response) {
        new theme.CartDrawer();
        //$('.off-canvas-cart').addClass('in');
        this.$ajaxSubmit.notify('Product Added To Cart',{ position:"bottom center", className: "success" });
        $('#upsell_widget_modal').show();
      },

      error: function(error) {
        this.$ajaxSubmit.notify(error,{ position:"top right", className: "error" });
      }
    });

    return AjaxProductAdd;
  })();

  theme.CartDrawer = (function() {
    var config = {
      namespace: '.ajaxcart'
    };


    function CartDrawer() {


      theme.genie.getCart().then(this.buildCart.bind(this));

      this.initEventListeners();
    };

    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function() {

      },

      buildCart: function(cart) {
        if (cart.item_count === 0) {

        }else{
          var amountToSubtract = 0;
          var amountToAdd = 0 ;
          var addOnExists = 0 ;
          var cartHTML = '' +

					'<div class="shop-icon-basket-inner">' +
						'<i class="' + cartIcon + '"></i>' +
						'<span class="cart-item-count">' + cart.item_count + '</span>' +
					'</div>';

				$('.shop-icon-basket-inner').replaceWith(cartHTML);

          		if( has_icon_text ) {

					var icon_text = '<span class="icon-label icon-label-cart"><span class="money">' + Shopify.formatMoney(cart.total_price) + '</span></span>';
					$('.icon-label-cart').replaceWith(icon_text);

				}

				var mobileCartHTML = '' +

					'<div class="mobile-cart-wrapper">' +
						'<a href="/cart" class="mobile-cart"><i class="' + cartIcon + '"></i></a>' +
						'<span class="cart-item-count">' + cart.item_count + '</span>' +
					'</div>';

				$('.mobile-cart-wrapper').replaceWith(mobileCartHTML);
          var itemHTML = '';
          var priceHTML           = '';
				var VATHTML             = '';

          $.each(cart.items, function(index, product) {
            	var addOn = 0;
                var addOnPrice = 0 ;
           		var addOnTitle = 0 ;
            	var addOnImage = 0 ;
            	var addOnMaxQuantity = 0 ;
            	var offer = 0 ;
                var offer = 0 ;
            var addOnDisplayPrice = 0 ;
               $.each(product.properties, function(key, value) {

                  switch(key) {
                    case 'type':
                      addOn = value;
                      break;
                    case 'title':
                      addOnTitle = value;
                      break;
                    case 'image':
                      addOnImage = value;
                      break;
                    case 'max':
                      addOnMaxQuantity = value;
                      break;
                    case 'offer':
                      offer = value;
                      break;
                    case 'price':
                      addOnPrice = parseFloat(value);
                 	  break;
                  }

                });

            if(addOn == 'addon'){
            	var trimmed_title       = addOnTitle.substring(0,20);

				addOnPrice = addOnPrice * product.quantity;
				addOnDisplayPrice = addOnPrice * 100;

                amountToAdd = amountToAdd + addOnPrice;
                var originalPrice = product.price * product.quantity;
                amountToSubtract =  originalPrice - amountToSubtract ;



				itemHTML = itemHTML + '' +

					'<div class="header-cart-contents-item d-flex">' +
						'<div class="header-cart-contents-product-image">' +
							'<a href="javascript:void(0);">' +
								'<img src="' + addOnImage + '" alt="' + addOnTitle + '">' +
							'</a>' +
						'</div>' +
						'<div class="header-cart-contents-product-details d-flex flex-column justify-content-center text-left">' +
							'<span class="header-cart-contents-product-quantity">' + theme.strings.qty + ' 1</span>' +
							'<h6 class="header-cart-contents-product-title">' +
								'<strong><a href="' + product.url + '">' + trimmed_title + '&hellip;</a></strong>' +
							'</h6>' +
							'<span class="header-cart-contents-product-price">' + Shopify.formatMoney(addOnDisplayPrice) + VATHTML + '</span>' +
						'</div>' +
					'</div>';
            }else{
            	var pos                 = product.image.lastIndexOf('.');
				var product_image_small = product.image.substring(0,pos) + '_120x120_crop_center.' + product.image.substring(pos+1);
				var trimmed_title       = product.title.substring(0,20);




				itemHTML = itemHTML + '' +

					'<div class="header-cart-contents-item d-flex">' +
						'<div class="header-cart-contents-product-image">' +
							'<a href="' + product.url + '">' +
								'<img src="' + product_image_small + '" alt="' + product.title + '">' +
							'</a>' +
						'</div>' +
						'<div class="header-cart-contents-product-details d-flex flex-column justify-content-center text-left">' +
							'<span class="header-cart-contents-product-quantity">' + theme.strings.qty + ' 1</span>' +
							'<h6 class="header-cart-contents-product-title">' +
								'<strong><a href="' + product.url + '">' + trimmed_title + '&hellip;</a></strong>' +
							'</h6>' +
							'<span class="header-cart-contents-product-price">' + Shopify.formatMoney(product.price) + VATHTML + '</span>' +
						'</div>' +
					'</div>';
            }




          });

          $('.header-cart-loop').html(itemHTML);
          if(amountToSubtract > 0){
                var subTotal = cart.total_price;
                subTotal = (subTotal - amountToSubtract) + (amountToAdd * 100);

           	if( displayVAT ) {

              var priceWithoutVAT = subTotal;
              var priceWithVAT    = subTotal * VATValue;

              priceHTML += '<span class="without-vat">' + Shopify.formatMoney(priceWithoutVAT) + '<span class="vat-text"> ' + VATTextWithout + '</span></span>';
              priceHTML += '<span class="with-vat">' + Shopify.formatMoney(priceWithVAT) + '<span class="vat-text"> ' + VATTextWith + '</span></span>';

              VATHTML = '<span class="vat-text">' + VATTextWithout + '</span>';

            } else {

              priceHTML += Shopify.formatMoney(subTotal);

            }
          }else{
          	if( displayVAT ) {

              var priceWithoutVAT = cart.total_price;
              var priceWithVAT    = cart.total_price * VATValue;

              priceHTML += '<span class="without-vat">' + Shopify.formatMoney(priceWithoutVAT) + '<span class="vat-text"> ' + VATTextWithout + '</span></span>';
              priceHTML += '<span class="with-vat">' + Shopify.formatMoney(priceWithVAT) + '<span class="vat-text"> ' + VATTextWith + '</span></span>';

              VATHTML = '<span class="vat-text">' + VATTextWithout + '</span>';

            } else {

              priceHTML += Shopify.formatMoney(cart.total_price);

            }
          }



          if(cart.item_count > 0) {
					$('.no-items').remove();
				}

				$('.header-cart-contents-total-value').html(priceHTML);

        }

      },


    });

    return CartDrawer;
  })();

  theme.UpsellProductRemove = (function() {
    var status = {
      loading: false
    };

    function UpsellProductRemove($el) {
      this.$el = $el;

      if (this.$el.length) {
        this.$el.on('click', this.saveForm.bind(this));
      }
    };

    UpsellProductRemove.prototype = $.extend({}, UpsellProductRemove.prototype, {
      saveForm: function(evt){
       evt.preventDefault();
		theme.genie.getCart().then(function(cart) {
          console.log(cart);
            this.checkRule(cart);
          }.bind(this));








      },

       checkRule: function(cart) {
        var canBeRemoved = true;
         var addonToRemoved = [];
        var variant = this.$el.data('variant');
		$.each(cart.items, function(index, product) {
          $.each(product.properties, function(key,value) {
              if(key == 'combo' && value == variant ){
                canBeRemoved = false;
                addonToRemoved.push(product.variant_id);
              }
            });
        });
         addonToRemoved.push(variant);

         if($('.cart-form').length > 0){
           $.each(addonToRemoved, function(key,variant) {
             $('.addonitem-'+variant).val(0);
             $('.item-'+variant).val(0);
           });

           $('.cart-form').submit();
         }else{
         	this.$el.parent().notify('Please go to cart page to remove this product ',{ position:"bottom center", className: "error" });
         }




      },
      success: function(response) {

      },

      error: function(error) {

      }
    });

    return UpsellProductRemove;
  })();





})(jQuery);
